import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConnectValidationConfig } from '../../canvas-elements/io-data/io-data.models';
import { ButtonValidationHandler } from '../button/button-validation-handler.service';

@Injectable({ providedIn: 'root' })
export class WizardValidationHandler extends ButtonValidationHandler {
  override connectValidation(config: ConnectValidationConfig): Observable<void> {
    return this.getFormGroupButtonValidation(config);
  }
}
